import { Dispatch } from 'react';
import { getUserToken, logout as apiLogout, me } from '../api';
import { Action } from '../stores/global/reducer';
import { removeUser } from './storage';

export async function logout(dispatch: Dispatch<Action>) {
  try {
    dispatch({ type: 'SET_LOADING', payload: true });
    await apiLogout();
  } finally {
    dispatch({ type: 'SET_USER', payload: undefined });
    dispatch({ type: 'SET_LOADING', payload: false });
    window.location.href = '/';
  }
}

export function openSigninOn401Error(dispatch: Dispatch<Action>, err: any) {
  const errorStatus = err?.response?.status;

  if (errorStatus === 401) {
    dispatch({ type: 'SET_LOGIN_MODAL', payload: 'signin' });
  } else {
    throw err;
  }
}

// TODO: handleApiGlobalError should close any global loading.
// This is deprecated as an API fn. Use the handleGlobalApiCalls
export function handleApiGlobalError(dispatch: Dispatch<Action>, err: any) {
  const errors = err?.response?.data?.errors;
  let errorMessage;
  let details;

  if (errors?.includes?.('E:session.not_found')) {
    removeUser();
    window.location.href = '/';
    return;
  } else if (errors?.includes('E:user.invalid_credentials')) {
    errorMessage = 'Credenciales inválidas';
  } else if (errors?.includes('E:user.already_registered')) {
    errorMessage = 'Correo ya registrado';
  } else if (errors?.includes('E:validation.not_found')) {
    errorMessage = 'Este enlace para validar expiró o no es válido';
  } else if (errors?.includes('E:name.any_required')) {
    errorMessage = 'Nombre requerido';
  } else if (errors?.includes('E:chat.not_found')) {
    errorMessage = 'Chat no existe';
  } else if (errors?.includes('E:phone.already_sent')) {
    errorMessage = 'Mensaje ya se ha enviado al celular';
  } else if (errors?.includes('E:meeting.too_many')) {
    errorMessage = 'Fecha y hora no disponible';
  } else if (errors?.includes('E:registrationNumber.already_registered')) {
    errorMessage = 'Número de matrícula ya existe';
  } else {
    let error = '';

    try {
      if (errors) {
        error = JSON.stringify(errors);
      } else {
        error = err?.message;
      }
    } catch (e) {
      error = err?.message;
    }

    errorMessage = 'Inténtalo más tarde';
    details = { summary: 'Detalles del error', content: error };
  }

  dispatch({
    type: 'SET_ALERT_MODAL',
    payload: { title: 'Ocurrió un error', message: errorMessage, details },
  });

  return { error: err, message: errorMessage };
}

export async function handleGlobalApiCalls(
  dispatch: Dispatch<Action>,
  isLoading: boolean,
  options: { initialLoading?: boolean } | null,
  promiseFn: () => Promise<any>
) {
  if (isLoading) return;

  dispatch({ type: 'SET_LOADING', payload: options?.initialLoading ?? true });

  try {
    return await promiseFn();
  } catch (err) {
    throw await handleApiGlobalError(dispatch, err);
  } finally {
    dispatch({ type: 'SET_LOADING', payload: false });
  }
}

export async function syncUser(
  dispatch: Dispatch<Action>,
  hideLoading = false
) {
  try {
    const token = getUserToken();
    if (!token) return;

    if (!hideLoading) dispatch({ type: 'SET_LOADING', payload: true });
    const response = await me();
    dispatch({ type: 'SET_USER', payload: { ...response.data.data, token } });

    if (!hideLoading) dispatch({ type: 'SET_LOADING', payload: false });
  } finally {
    if (!hideLoading) dispatch({ type: 'SET_LOADING', payload: false });
  }
}
